import React, { Component } from "react";
import errorConfig from "../../config/errorConfig.json";
import { getFromStorage } from "../../utils/storage";
import { withRouter } from "react-router-dom";
import key from "../../config/key.json";
import { Table, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import ReactToPrint from "react-to-print";
import apiURL from "../../config/api.json";
import axios from "axios";
import { DateRange } from "react-date-range";
import moment from "moment";
import { Dialog, DialogTitle, DialogContent, Button, DialogActions } from "@material-ui/core";
import { CloudDownload, Print } from "@material-ui/icons";


let startDate = "", endDate = "";

class Bill extends Component {
  state = { 
    tableData: [],
    selectRange: [{
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    }],
    open: false,
    flag: false
  };

  //Download as word file
  downloadDocx = () => {
    axios
      .post(
        apiURL.postMethodWordURL,
        {
          rows: this.state.tableData
        },
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          responseType: "blob"
        }
      )
      .then(res => {
        const file = new Blob([res.data], {
          type:
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        });

        const fileURL = URL.createObjectURL(file);
        let a = document.createElement("a");
        a.href = fileURL;
        a.download = "Bill.docx";
        a.click();
      })
      .catch(err => {
        this.notifyError(err.toString());
      });
  };

  //Checking date
  dateError = () => {
    const FromDate = new Date(this.state.fromDate);
    const ToDate = new Date(this.state.toDate);
    if (FromDate > ToDate) {
      this.notifyError(errorConfig.fromDateError);
      return false;
    } else {
      if (getFromStorage(key.loginInfoKey)) {
        return true;
      }
    }
  };

  //Error Notification
  notifyError = error => {
    toast.error("" + error.toString());
  };

  //For Today, This week and last 7 days set dates
  setDates = (type) => {
    if(type === "Today") {
      startDate = new Date();
      endDate = new Date();
    } else if(type === "This Week") {
      var current = new Date(); 
      var weekstart = current.getDay() === 0 ? current.getDate() - current.getDay() - 6 : current.getDate() - current.getDay() + 1; 
      startDate = new Date(current.setDate(weekstart));  
      endDate = new Date();  
    } else {
      var currentDate = new Date(); 
      var start =  currentDate.getDate() - 6; 
      startDate = new Date(currentDate.setDate(start));  
      endDate = new Date(); 
    }
    this.setState({ 
        selectRange: [
          {
            startDate,
            endDate,
            key: 'selection',
          }
        ],
        open: false 
    })
  }

  //First function run when page load
  componentDidMount() {
    toast.dismiss();
    if (!getFromStorage(key.loginInfoKey)) {
      this.notifyError(errorConfig.notLoggedInError);
      this.props.history.push("/");
    } else if (getFromStorage(key.loginInfoKey).task === "authAdmin") {
      this.setState({
        tableData: [
          { item_number: 1, rate: 23, count: 180, item_total: 9030 },
          { item_number: 2, rate: 230, count: 110, item_total: 9100 },
          { item_number: 3, rate: 233, count: 140, item_total: 9040 },
          { item_number: 4, rate: 232, count: 120, item_total: 9006 }
        ]
      });
    } else if (getFromStorage(key.loginInfoKey).task === "authDiagAdminPanel"){
      this.setState({
        tableData: [
          { item_number: 1, rate: 23, count: 180, item_total: 9030 },
          { item_number: 2, rate: 230, count: 110, item_total: 9100 },
          { item_number: 3, rate: 233, count: 140, item_total: 9040 },
          { item_number: 4, rate: 232, count: 120, item_total: 9006 }
        ]
      });
    } else if (getFromStorage(key.loginInfoKey).task === "patient" || getFromStorage(key.loginInfoKey).task === "doctor") {
      this.props.history.push("/home");
    } else if (getFromStorage(key.loginInfoKey).task === "provider") {
      this.props.history.push("/provider_doctors")
    }
  }

  render() {
    if (getFromStorage(key.loginInfoKey)) {
      return (
        <div 
          style={{ marginLeft: "80px", color: "teal", marginRight: "20px", marginTop: "110px" }} 
          align="center"
        >
              <Form.Group>
                <Form.Label style={{fontWeight: "bold", display: "block"}}>Date</Form.Label>
                <Form.Control type="text" placeholder="Select Date" size="sm" onChange={(e) => {}} value={this.state.flag ? `${moment(this.state.selectRange[0].startDate).format("DD.MM.YYYY")} - ${moment(this.state.selectRange[0].endDate).format("DD.MM.YYYY")}`: ""} 
                  onClick={() => {this.setState({open: true})}} style={{width: "300px", marginLeft: "auto", marginRight: "auto", display: "inline", textAlign: "center"}}/>
              </Form.Group>
              <Table
                bordered
                striped
                hover
                style={{
                  width: "80%",
                  marginLeft: "auto",
                  marginRight: "auto",
                  backgroundColor: "white",
                  marginTop: "20px",
                  marginBottom: "20px"
                }}
                size="sm"
                align="center"
                ref={el => (this.componentRef = el)}
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Rate</th>
                    <th>Count</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.tableData.map(item => (
                    <tr key={item.item_number}>
                      <td>{item.item_number}</td>
                      <td>{item.rate}</td>
                      <td>{item.count}</td>
                      <td>{item.item_total}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <ReactToPrint
                trigger={() => 
                  <Button variant="contained" style={{backgroundColor: "green", textTransform: "none"}} size="small">
                   <Print style={{color: "white"}}/> <span style={{marginLeft: "5px", color: "white"}}>Print Bill</span>
                  </Button>}
                content={() => this.componentRef}
              />
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={this.downloadDocx}
                style={{ marginLeft: "30px", textTransform: "none" }}
              >
                <CloudDownload/> <span style={{marginLeft: "5px"}}>Download as Word File</span>
              </Button>
            {/* </Card.Body>
          </Card> */}
          {/*Start of Dialog*/}
          <Dialog open={this.state.open} aria-labelledby="form-dialog-title">
            {/*Start of Dialog Title*/}
            <DialogTitle id="form-dialog-title" style={{ color: "#484848" }}>
              Select Date
            </DialogTitle>
            {/*End of Dialog Title*/}

            {/*Start of Dialog Content*/}
            <DialogContent style={{textAlign: "center"}} dividers>
              <Button
                style={{textTransform: "none", borderColor: "green", color: "green"}} 
                variant="outlined" 
                size="small"
                onClick={() => this.setDates("Today")}
              >
                Today
              </Button>
              <Button 
                style={{textTransform: "none", marginLeft: "10px", borderColor: "green", color: "green"}} 
                variant="outlined"
                size="small"
                onClick={() => this.setDates("This Week")}
              >
                This Week
              </Button>
              <Button 
                style={{textTransform: "none", marginLeft: "10px", borderColor: "green", color: "green"}} 
                variant="outlined" 
                size="small"
                onClick={() => this.setDates("Last 7 Days")}
              >
                Last 7 Days
              </Button>
              <br/>
              <br/>
              <DateRange
                ranges={this.state.selectRange}
                onChange={(item) => this.setState({ 
                              selectRange: [item.selection], 
                        })}
              />
              <br />
              <br />
            </DialogContent>
            {/*End of Dialog Content*/}

            {/*Start of Dialog Actions*/}
            <DialogActions>
              <Button
                onClick={() => this.setState({open:false, flag: true})}
                variant="contained"
                color="primary"
                style={{ textTransform: "none" }}
                className="primary"
              >
                Ok
              </Button>
            </DialogActions>
            {/*End of Dialog Actions*/}
          </Dialog>
          {/*End of Dialog*/}
        </div>
      );
    } else {
      return <div></div>;
    }
  }
}

export default withRouter(Bill);
